export const DEFAULT_OVERTIME_HOUR_RATES = {
  overtimePaidHourMultiplier: 1.5,
  overtimeCompensatoryHourMultiplier: 1,
};

export function parseOvertimeHourMultiplier(value, fallback) {
  const num = Number(value);
  if (!Number.isFinite(num) || num < 0.25 || num > 5) {
    return fallback;
  }
  return Math.round(num * 100) / 100;
}

export function ratesFromRegulation(reg) {
  return {
    overtimePaidHourMultiplier: parseOvertimeHourMultiplier(
      reg?.overtimePaidHourMultiplier,
      DEFAULT_OVERTIME_HOUR_RATES.overtimePaidHourMultiplier,
    ),
    overtimeCompensatoryHourMultiplier: parseOvertimeHourMultiplier(
      reg?.overtimeCompensatoryHourMultiplier,
      DEFAULT_OVERTIME_HOUR_RATES.overtimeCompensatoryHourMultiplier,
    ),
  };
}

export function applyOvertimeHourMultiplier(hours, multiplier) {
  const h = Number(hours);
  const m = Number(multiplier);
  if (!Number.isFinite(h) || !Number.isFinite(m) || h <= 0) return 0;
  return Math.round(h * m * 100) / 100;
}

export function formatOvertimeHourMultiplierAr(multiplier) {
  const n = Number(multiplier);
  if (n === 1) return "ساعة بساعة";
  if (n === 1.5) return "ساعة ونصف";
  if (n === 2) return "ساعتين";
  if (n === 0.5) return "نصف ساعة";
  const trimmed = Number.isInteger(n)
    ? String(n)
    : String(Math.round(n * 100) / 100);
  return `${trimmed} ساعة`;
}

export function paidOvertimeRateHint(multiplier) {
  return `صرف مالي: الساعة تُحسب ${formatOvertimeHourMultiplierAr(
    multiplier,
  )} في المرتب`;
}

export function compensatoryOvertimeRateHint(multiplier) {
  return `تعويضي: الساعة تُحسب ${formatOvertimeHourMultiplierAr(
    multiplier,
  )} رصيد ساعات`;
}
